import React, { Component, PropTypes } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ProductDropdown from './ProductDropdown';
import QuantityField from './QuantityField';

class DiagnosticToolItem extends Component {
  constructor(props) {
    super(props);

    this._onProductChange = this._onProductChange.bind(this);
    this._onQuantityChange = this._onQuantityChange.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return shallowCompare(this, nextProps);
  }

  _onProductChange(val) {
    this._onChange({
      product_id: val,
    });
  }

  _onQuantityChange({ value, unit }) {
    this._onChange({
      quantity: value ? Number(value) : undefined,
      quantity_unit_ref: unit ? Number(unit) : undefined,
    });
  }

  _onChange(values) {
    const { tool } = this.props;

    this.props.onChange(tool, values);
  }

  render() {
    const { tool, products, units, onDelete } = this.props;

    const deleteTool = evt => {
      evt.preventDefault();
      onDelete(tool);
    };

    return (
      <tr>
        <td>
          <button className="ui basic red icon button" onClick={deleteTool}>
            <i className="remove icon" />
          </button>
        </td>
        <td>
          <div className="field wide">
            <ProductDropdown
              value={tool.product_id}
              products={products}
              onChange={this._onProductChange}
            />
          </div>
        </td>
        <td>
          <div className="field wide">
            <QuantityField
              value={tool.quantity}
              unit={tool.quantity_unit_ref}
              units={units}
              onChange={this._onQuantityChange}
            />
          </div>
        </td>
      </tr>
    );
  }
}

DiagnosticToolItem.propTypes = {
  tool: PropTypes.object.isRequired,
  products: ImmutablePropTypes.set.isRequired,
  units: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default DiagnosticToolItem;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/components/DiagnosticToolItem.js